var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReadytodeliver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M50.7793 100C78.3935 100 100.779 77.6142 100.779 50C100.779 22.3858 78.3935 0 50.7793 0C23.1651 0 0.779297 22.3858 0.779297 50C0.779297 77.6142 23.1651 100 50.7793 100Z",
    fill: "#BFC6D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5439 33H31.8066C30.5602 33 29.5498 34.0104 29.5498 35.2568V61.0825C29.5498 62.3289 30.5602 63.3394 31.8066 63.3394H60.5439C61.7903 63.3394 62.8007 62.3289 62.8007 61.0825V35.2568C62.8007 34.0104 61.7903 33 60.5439 33Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9969 34V45.1241C50.0075 45.2094 49.9909 45.2958 49.9494 45.3711C49.9079 45.4464 49.8437 45.5066 49.7659 45.5432C49.6881 45.5797 49.6007 45.5908 49.5163 45.5747C49.4319 45.5586 49.3547 45.5163 49.2958 45.4537L46.2996 42.2538C46.2631 42.2098 46.2173 42.1744 46.1655 42.1501C46.1137 42.1257 46.0572 42.1131 46 42.1131C45.9428 42.1131 45.8863 42.1257 45.8345 42.1501C45.7827 42.1744 45.7369 42.2098 45.7004 42.2538L42.7042 45.4537C42.6453 45.5163 42.5681 45.5586 42.4837 45.5747C42.3993 45.5908 42.3119 45.5797 42.2341 45.5432C42.1563 45.5066 42.0921 45.4464 42.0506 45.3711C42.0091 45.2958 41.9925 45.2094 42.0031 45.1241V34H49.9969Z",
    fill: "#5F768C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7809 58.5767C42.6057 58.5767 44.8957 60.8667 44.8957 63.6914C44.8957 66.5162 42.6057 68.8073 39.7809 68.8073C36.9561 68.8073 34.665 66.5162 34.665 63.6914C34.665 60.8667 36.9551 58.5767 39.7809 58.5767ZM78.1466 58.5767C80.9714 58.5767 83.2614 60.8667 83.2614 63.6914C83.2614 66.5162 80.9714 68.8073 78.1466 68.8073C75.3218 68.8073 73.0318 66.5162 73.0318 63.6914C73.0318 60.8667 75.3218 58.5767 78.1466 58.5767Z",
    fill: "#BFC6D0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3799 56.0166V63.6904H83.264C83.264 60.8657 80.974 58.5756 78.1492 58.5756C75.3245 58.5756 73.0344 60.8657 73.0344 63.6904H62.8027V50.9019H83.264C86.077 50.9019 88.3799 53.2037 88.3799 56.0166Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1483 50.9021H62.8018V40.6704H70.4745C74.7127 40.6704 78.1483 50.9021 78.1483 50.9021Z",
    fill: "#BFC6D0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5498 43.5V63.6907H34.6646",
    stroke: "#5F768C",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8008 40.6727V35.5579C62.8008 34.1509 61.6499 33 60.2418 33H32.1068C30.7008 33 29.5488 34.1498 29.5488 35.5579V38.1116",
    stroke: "#5F768C",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8975 63.6904H62.803",
    stroke: "#5F768C",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8027 50.9021V40.6704H70.4754C74.7137 40.6704 78.1492 50.9021 78.1492 50.9021M62.8027 50.9021H83.264C86.077 50.9021 88.3799 53.2039 88.3799 56.0169V63.6907H83.264M62.8027 50.9021V63.6907H73.0344",
    stroke: "#5F768C",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2625 63.6914C83.2625 66.5162 80.9724 68.8073 78.1477 68.8073C75.3229 68.8073 73.0329 66.5162 73.0329 63.6914C73.0329 60.8667 75.3229 58.5767 78.1477 58.5767C80.9724 58.5767 83.2625 60.8667 83.2625 63.6914ZM44.8957 63.6914C44.8957 66.5162 42.6057 68.8073 39.7809 68.8073C36.9561 68.8073 34.665 66.5162 34.665 63.6914C34.665 60.8667 36.9551 58.5767 39.7809 58.5767C42.6067 58.5767 44.8957 60.8667 44.8957 63.6914Z",
    stroke: "#5F768C",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5796 43.1846H20.8975",
    stroke: "#5F768C",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6783 50.3467H20.5781",
    stroke: "#5F768C",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9778 50.3467H14.8613",
    stroke: "#5F768C",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9886 57.5049H14",
    stroke: "#5F768C",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M39 32.5C39 36.6421 35.6421 40 31.5 40C27.3579 40 24 36.6421 24 32.5C24 28.3579 27.3579 25 31.5 25C35.6421 25 39 28.3579 39 32.5Z",
    fill: "#5F768C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0562 29.8776C35.3146 30.1311 35.3146 30.542 35.0562 30.7955L30.6444 35.1224C30.3859 35.3759 29.967 35.3759 29.7085 35.1224L27.9438 33.3916C27.6854 33.1381 27.6854 32.7273 27.9438 32.4738C28.2023 32.2203 28.6213 32.2203 28.8797 32.4738L30.1765 33.7456L32.1484 31.8116L34.1203 29.8776C34.3788 29.6241 34.7977 29.6241 35.0562 29.8776Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadytodeliver);
export default __webpack_public_path__ + "static/media/readytodeliver.7c5b0e9775d6b3b4b4ff15ac76b4c222.svg";
export { ForwardRef as ReactComponent };